export const coreAddresses = {
  balanceTracker: "0x7A49f3b99d5737c1D3dcF9F278a8568ed4092416",
  eVaultFactory: "0xD17587B7da4383bE4b64bD2D0c87119a17Ee5130",
  eVaultImplementation: "0x927dBf538B7A02491268e53748546730706a0fDc",
  eulerEarnFactory: "0x0000000000000000000000000000000000000000",
  evc: "0x59B8DfBcD3F004e7287eA021A67D54763fEAeE0C",
  permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  protocolConfig: "0x41fa2486c164840B49663D422eb7E1Ee19C4FB23",
  sequenceRegistry: "0x4790c32228a704B635d7c50f91CefD3A0F77E721",
} as const
